
import React from 'react';

const SkillImprovementSection: React.FC = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">能力不够怎么办？</h2>
          <p className="text-xl text-gray-600">专家教学+AI赋能，帮你打造差异化竞争力</p>
        </div>

        <div className="space-y-8">
          <div className="bg-white p-8 rounded-xl shadow-lg">
            <div className="flex flex-col lg:flex-row items-center gap-8">
              <div className="lg:w-1/2">
                <img 
                  src="https://static.readdy.ai/image/369c6d7d3639e005f7b761af84a5109d/03d757083e30709c03594c71e833436d.png"
                  alt="资深专家教学"
                  className="w-full h-32 md:h-64 object-cover rounded-lg"
                />
              </div>
              <div className="lg:w-1/2">
                <h4 className="text-2xl font-bold text-gray-900 mb-3">达不到招聘要求怎么办？</h4>
                <p className="text-lg text-blue-600 font-semibold mb-4">资深专家手把手教学</p>
                <p className="text-gray-700 leading-relaxed">行业顶尖专家一对一指导，传授实战经验和核心技能。我们的导师团队来自各行业领军企业，拥有丰富的实战经验，为您提供个性化的专业指导，快速提升专业能力和职场竞争力。</p>
              </div>
            </div>
          </div>
          
          <div className="bg-white p-8 rounded-xl shadow-lg">
            <div className="flex flex-col lg:flex-row-reverse items-center gap-8">
              <div className="lg:w-1/2">
                <img 
                  src="https://static.readdy.ai/image/369c6d7d3639e005f7b761af84a5109d/766879f15c27aba53f9caece77d379f6.png"
                  alt="内部项目实训"
                  className="w-full h-32 md:h-64 object-cover rounded-lg"
                />
              </div>
              <div className="lg:w-1/2">
                <h4 className="text-2xl font-bold text-gray-900 mb-3">学校专业落后于行业前沿5-10年怎么办？</h4>
                <p className="text-lg text-green-600 font-semibold mb-4">顶尖公司内部项目实训</p>
                <p className="text-gray-700 leading-relaxed">参与真实项目实战，积累宝贵工作经验。我们提供来自合作企业的真实项目，让您在实践中学习，在项目中成长，建立专业作品集，为求职增加实战经验和成功案例。</p>
              </div>
            </div>
          </div>
          
          <div className="bg-white p-8 rounded-xl shadow-lg">
            <div className="flex flex-col lg:flex-row items-center gap-8">
              <div className="lg:w-1/2">
                <img 
                  src="https://public.readdy.ai/ai/img_res/cbd4d7562dc888f3278d3e11da6e5cd5.jpg"
                  alt="AI提升工作能力"
                  className="w-full h-32 md:h-64 object-cover rounded-lg"
                />
              </div>
              <div className="lg:w-1/2">
                <h4 className="text-2xl font-bold text-gray-900 mb-3">担心未来被AI淘汰怎么办？</h4>
                <p className="text-lg text-purple-600 font-semibold mb-4">掌握前沿科技，AI全面赋能</p>
                <p className="text-gray-700 leading-relaxed">运用最新AI工具提升工作效率，掌握未来职场必备技能。我们教授最前沿的AI应用技术，帮您掌握人工智能时代的核心竞争力，让您在职场中脱颖而出，成为不可替代的人才。</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SkillImprovementSection;
